import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Gate photos need the auth header, so load them as blobs.
export default function AuthPhoto({ path, className = "", testId }) {
  const [src, setSrc] = useState("");
  useEffect(() => {
    if (!path) return undefined;
    let url = "";
    api.get("/gate-passes/photo", { params: { path }, responseType: "blob" })
      .then((r) => { url = URL.createObjectURL(r.data); setSrc(url); })
      .catch(() => {});
    return () => url && URL.revokeObjectURL(url);
  }, [path]);
  if (!path) return null;
  return src
    ? <a href={src} target="_blank" rel="noreferrer"><img src={src} alt="Vehicle" data-testid={testId} className={className} /></a>
    : <div className={`${className} bg-canvas-panel`} />;
}
